import { render } from "./sponsors.vue?vue&type=template&id=7ce4bc33&scoped=true"
import script from "./sponsors.vue?vue&type=script&lang=js"
export * from "./sponsors.vue?vue&type=script&lang=js"

import "./sponsors.vue?vue&type=style&index=0&id=7ce4bc33&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7ce4bc33"

export default script